<template>
    <div>
        <div v-for="(contact,index) of contacts" :key="index">{{ contactType(contact.contact_group,contact.contact_type) }}: {{ formatContact(contact) }}</div>
    </div>
</template>
<script>
export default{
    name:'ReClientContacts',
    props:{
        contacts: Array
    },
    methods:{
        contactType(group,type){
            if(type==44) group = 'intphone';
            try{
                return this.$GVO.cats.CONTACTS_TYPES[group].types[type]||group+type;
            }catch(e){
                return group+type;
            }
        },
        formatContact(contact){
            // console.log('contact', contact)
            if(contact.contact_group=='phone' && !contact.contact_foreign && contact.contact_type!=='44')
                return this.$GVO.formatPhoneNumber(contact.contact_value)
            return String(contact.contact_value).match(/.{1,3}/g).join(' ');
        },
    }
}
</script>